module.exports = __webpack_public_path__ + "img/A-31836-1127764513.jpeg.183e06c4.jpg";